import { useEffect, useState } from "react";
import { IEditBaseControllerReturn } from "../../controllers/EditBaseController";
import { IModalOkCancelControllerReturn } from "../../../../../commonreact/main/components/modals/modalok/ModalOKCancelController";
import Email from "../../../logic/models/Email";
import { t } from "i18next";
import { EModalOkType } from "../../../../../commonreact/main/components/modals/modalok/ModalOKEnums";
import { ELng } from "../../../../../language/main/LanguageKeysEnums";
import ServerEMailAPIService from "../../../server/serverapi/ServerEMailAPIService";
import { EmailJSONMappingService } from "../../../server/mappings/email/EmailJSONMappingService";


interface IProps {
  ebc: IEditBaseControllerReturn;
  mokcc: IModalOkCancelControllerReturn;
  email:Email;
}

export interface IServiceControllerReturn {
  //states
  email: Email | null;
  sendIsEnabled: boolean;
  render: boolean;
  //functions
  handleEvents: () => void;
  sendEmail: () => void;
}

export const ServiceController = (props: IProps): IServiceControllerReturn => {

  const tag = "ServiceController";

  //states
  const [hasDirtyData, setHasDirtyData] = useState<boolean>(false);
  const [isValid, setIsValid] = useState<boolean>(false);
  const [sendIsEnabled, setSendIsEnabled] = useState<boolean>(false);
  useEffect(() => {
    console.log(tag + "sendIsEnabled: "+sendIsEnabled)
  }, [sendIsEnabled]);

  const  [email, setEmail] = useState<Email | null>(null);
  const  [render, setRender] = useState<boolean>(false);  

  useEffect(() => {
    setEmail(props.email); 
    
    //!!hint: workaround for infinit render-loop, keept it until you do not find a better solution
    setTimeout(()=>{
      if(render == true) return;
      setRender(true),100
    })
  }, [])

  //#region events
  const handleEvents = () => {
    console.log(tag + " handleEvents()");
    handleDirytDataEvent();
    handleValidDataEvent();
    handleSendEnabledEvent();
  }

  const handleDirytDataEvent = () => {
    if (email == null) return
    setHasDirtyData(email.hasDirtyData)
  }

  const handleValidDataEvent = () => {
    if (email == null) return
    if (isValid == email.isValid) return;
    setIsValid(email.isValid);
  }

  const handleSendEnabledEvent = () => {
    if (email == null) { setSendIsEnabled(false); return; }
    if (!email.hasDirtyData) { setSendIsEnabled(false); return; }
    if (!email.isValid) { setSendIsEnabled(false); return; }
    setSendIsEnabled(true);
  }
  //#endregion


  const sendEmail = () => {
    if(email == null) return;
    props.ebc.setIsSubmitting(true);
    const json = EmailJSONMappingService.mapEmailToNewJson(email);
    //const json = email?.getJson();
   
    ServerEMailAPIService.send(json).then((result) => {
      props.mokcc.setContentAndShow({ type: EModalOkType.Success, title: t(ELng.title_success_on_email_send.valueOf()), 
        text: t(ELng.msg_success_on_email_send.valueOf()) })
    }).catch((e) => {
      props.mokcc.setContentAndShow({ title: t(ELng.title_error_on_email_send.valueOf()), text: t(e) })
    }).finally(()=> {
      props.ebc.setIsSubmitting(false);
    })
  }

  //#region serverService
  //#endregion

  return {
    //states
    email,
    sendIsEnabled,
    render,
    //functions
    handleEvents,
    sendEmail
  }
}